import { OFFER_TYPE } from "../reducers/offer";

export const getTrackingInfoOffer = offer => {
    let supplyType = '';
    if (offer.energy.length > 0 && offer.gas.length > 0) {
        supplyType = 'lucegas';
    } else if (offer.energy.length > 0) {
        supplyType = 'luce';
    } else {
        supplyType = 'gas';
    }

    let offerType = 'bio';
    if (offer.offerType !== OFFER_TYPE.bio) {
        offerType = 'mono';
    }

    return ({
        sv1: offerType,
        sv2: supplyType,
        sv3: 'domestico',
        productId: offer.offerId,
        productName: offer.name
    });
}